/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { EXTERNAL_GOOGLE_PLATFORM_JS_LIBRARY_URL } from '@gh/config';
import { defer$ } from '@gh/rx';
import { Observable } from 'rxjs';
import { ResourceLoader } from '../common/resource-loader.service';

const GOOGLE_API_LOAD_TIMEOUT = 10000;

const getApiName = (name: string) => `gapi.${name}`;

@Injectable()
export class GoogleApiLoader {
  constructor(private loader: ResourceLoader) {
    loader.define('gapi', EXTERNAL_GOOGLE_PLATFORM_JS_LIBRARY_URL);
  }

  load(...names: string[]): Observable<boolean> {
    const notLoadedApi = names.filter((name) => !this.loader.isDefined(getApiName(name)));
    if (notLoadedApi.length > 0) {
      notLoadedApi.forEach((name) => {
        this.loader.define(
          getApiName(name),
          defer$(() => new Promise((resolve, reject) => gapi.load(name, {
            callback: resolve,
            onerror: reject,
            ontimeout: reject,
            timeout: GOOGLE_API_LOAD_TIMEOUT,
          }))),
          ['gapi']);
      });
    }
    return this.loader.require(...names.map(getApiName));
  }
}
